import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTableModule } from '@angular/material/table';
import { BillingUiModule } from '@vendasta/billing-ui';
import { GalaxyAvatarModule } from '@vendasta/galaxy/avatar';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { GalaxyFrequencyModule } from '@vendasta/galaxy/frequency';
import { GalaxyInputModule } from '@vendasta/galaxy/input';
import { GalaxyTableModule } from '@vendasta/galaxy/table';
import { ItemCommonModule } from '../common/item-common.module';
import { PackageContentsPopoverModule } from '../package-contents-popover/package-contents-popover.module';
import { ItemPricingTableComponent } from './item-pricing-table.component';
import { MultiActivatableDialogComponent } from './multi-activatable-dialog/multi-activatable-dialog.component';
import { FormatWholesaleMinimumHintPipe } from './pipes/format-wholesale-minimum-hint.pipe';
import { HasSetupFeePipe } from './pipes/has-setup-fee.pipe';
import { IsSetupFeeRemovablePipe } from './pipes/is-setup-fee-removable.pipe';
import { GalaxyFrequencyToRevenuePeriodPipe } from '../billing-term-dialog/sales-to-galaxy-frequency.pipe';
import { FormatBillingTermPipe } from './pipes/format-billing-term.pipe';

export const ITEM_PRICING_TABLE_DECLARATIONS = [
  ItemPricingTableComponent,
  MultiActivatableDialogComponent,
  FormatWholesaleMinimumHintPipe,
  HasSetupFeePipe,
  IsSetupFeeRemovablePipe,
  FormatBillingTermPipe,
];

export const ITEM_PRICING_TABLE_IMPORTS = [
  CommonModule,
  ItemCommonModule,
  MatButtonModule,
  MatDialogModule,
  MatIconModule,
  MatMenuModule,
  MatTableModule,
  BillingUiModule,
  GalaxyFormFieldModule,
  GalaxyAvatarModule,
  GalaxyFrequencyModule,
  GalaxyInputModule,
  GalaxyTableModule,
  PackageContentsPopoverModule,
  GalaxyFrequencyToRevenuePeriodPipe,
];

@NgModule({
  exports: [ItemPricingTableComponent],
  declarations: ITEM_PRICING_TABLE_DECLARATIONS,
  imports: ITEM_PRICING_TABLE_IMPORTS,
})
export class ItemPricingTableModule {}
